import React from 'react';
import { FaFilePdf, FaCertificate, FaShieldAlt, FaCheckCircle, FaBuilding, FaDownload } from 'react-icons/fa';

const CertificationsSection = () => {
  return (
    <section className="py-16 lg:py-24 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-navy-900 rounded-full mb-6">
            <FaShieldAlt className="text-4xl text-white" />
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 text-navy-900 dark:text-white">
            Licensed & Certified
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            We are a fully registered and compliant consulting firm in Tanzania, operating with all required legal certifications and government approvals
          </p>
        </div>

        {/* Documents Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            {
              title: "Business License",
              description: "Officially licensed to operate",
              file: "/documents/BUSINESS LICENSE.pdf",
              icon: FaCertificate
            },
            {
              title: "Certificate of Incorporation",
              description: "Registered company entity",
              file: "/documents/Certificate of Incorporation.pdf",
              icon: FaBuilding
            },
            {
              title: "TRA Registration",
              description: "Tanzania Revenue Authority",
              file: "/documents/TANZANIA REVENUE AUTHORITY.pdf",
              icon: FaShieldAlt
            },
            {
              title: "TRA Clearance",
              description: "Tax compliance certificate",
              file: "/documents/TRA CLEARANCE .pdf",
              icon: FaCheckCircle
            }
          ].map((doc, index) => {
            const IconComponent = doc.icon;
            return (
              <a
                key={index}
                href={doc.file}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-gray-50 dark:bg-gray-800 rounded-xl p-6 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-gray-200 dark:border-gray-700 hover:border-navy-900 dark:hover:border-navy-900"
              >
                {/* Icon */}
                <div className="flex justify-between items-start mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-navy-900 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="text-3xl text-white" />
                  </div>
                  <div className="text-gray-400 group-hover:text-navy-900 transition-colors duration-300">
                    <FaFilePdf className="text-2xl" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-lg font-bold mb-3 text-navy-900 dark:text-white">
                  {doc.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-6 leading-relaxed">
                  {doc.description}
                </p>

                {/* Download Button */}
                <div className="flex items-center font-semibold text-sm text-navy-900 dark:text-secondary-400 group-hover:gap-2 transition-all duration-300">
                  <FaDownload className="text-xs" />
                  <span className="ml-2">View Document</span>
                </div>
              </a>
            );
          })}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 bg-navy-900 dark:bg-gray-800 rounded-2xl p-8 text-center shadow-xl">
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="flex items-center space-x-3">
              <div className="w-14 h-14 bg-secondary-500 rounded-full flex items-center justify-center shadow-lg">
                <FaCheckCircle className="text-white text-2xl" />
              </div>
              <div className="text-left">
                <div className="font-bold text-white text-lg">Fully Licensed</div>
                <div className="text-sm text-gray-200">Government Approved</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-14 h-14 bg-secondary-500 rounded-full flex items-center justify-center shadow-lg">
                <FaShieldAlt className="text-white text-2xl" />
              </div>
              <div className="text-left">
                <div className="font-bold text-white text-lg">Tax Compliant</div>
                <div className="text-sm text-gray-200">TRA Certified</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-14 h-14 bg-secondary-500 rounded-full flex items-center justify-center shadow-lg">
                <FaBuilding className="text-white text-2xl" />
              </div>
              <div className="text-left">
                <div className="font-bold text-white text-lg">Registered Entity</div>
                <div className="text-sm text-gray-200">Legal Business</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
